import { render, staticRenderFns } from "./linkRolesTable.vue?vue&type=template&id=fefee0d0"
import script from "./linkRolesTable.vue?vue&type=script&lang=js"
export * from "./linkRolesTable.vue?vue&type=script&lang=js"
import style0 from "./linkRolesTable.vue?vue&type=style&index=0&id=fefee0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports